/**
 * Setup the environment for foam items
 */
import { Logger } from '../../../../../FrontendBundle/Resources/js/ofcs';
import DynamicCollisionView from '../collision/view/dynamicCollisionView';

/**
 * Setup the environment for foam items
 */
export default class FoamItemEnvironment {
    /**
     * @param {AbstractItem} item
     * @param {Pimple} container
     */
    constructor(item, container) {
        this.item = item;

        this.container = container;
        this.validator = container.get('canvas.validator');
        this.layerManager = container.get('canvas.svg.layerManager');
        this.contextManager = container.get('canvas.contextManager');
        this.pathFactory = container.get('canvas.svg.pathFactory');
        this.itemFactory = container.get('canvas.itemFactory');
        this.guideManager = container.get('canvas.guideManager');
        this.gridView = container.get('canvas.svg.gridView');
    }

    init() {
        Logger.debug('FoamItemEnvironment.init():', this.item);

        this.context = new Ofcs.Editor.Context.Context(this.item, 'foam');

        this.itemLayer = this.layerManager.createItemLayer(this.item, {
            transform: this.pathFactory.getAbsoluteTransformString(this.item),
        });

        const marginColor = this.container.get('editor.color.marginColor');

        this.layerManager.createLayer('foam', null, false, this.itemLayer);
        this.layerManager.createLayer('grid', null, false, this.itemLayer);
        // eslint-disable-next-line max-len
        this.layerManager.createLayer('sensor', { 'stroke-width': 1, 'stroke-opacity': 0.6, stroke: '#ff7000', 'fill-opacity': 0, style: 'pointer-events: none' }, false, this.itemLayer);
        this.layerManager.createLayer('margins', { fill: marginColor, opacity: 0.35 }, false, this.itemLayer);
        this.layerManager.createLayer('bags', { fill: `url(#bagBackground-${this.item.cid})` }, false, this.itemLayer);
        this.layerManager.createLayer('texts', null, false, this.itemLayer);
        this.layerManager.createLayer('images', null, false, this.itemLayer);

        // Move item layer when the foam item is moved inside a box
        this.item.on('change', (foam) => {
            if (foam.hasChangedProperty('position')) {
                this.itemLayer.getElement().attr('transform', this.pathFactory.getAbsoluteTransformString(foam, true));
            }
        });

        if (this.item.get('drawerExtraction')) {
            // TODO: multiple foams?
            this.extractionMarkerView = this.container.get('canvas.svg.extractionMarkerView');
        }

        // This layer should be child of items-overlay layer
        const dynamicCollisionLayer = this.layerManager.createLayer('collisions', null, false, this.itemLayer);
        dynamicCollisionLayer.getElement().css('pointer-events', 'none');

        this.dynamicCollisionView = new DynamicCollisionView(
            this.item,
            dynamicCollisionLayer,
            this.container.get('canvas.selection'),
            this.pathFactory,
        );
    }

    activate() {
        Logger.debug('FoamItemEnvironment.activate():', this.item);

        this.itemLayer.show();
        this.contextManager.addContext(this.context);
        this.validator.watchContainerItem(this.item);

        if (this.extractionMarkerView) this.extractionMarkerView.setFoam(this.item);
        if (this.guideManager) this.gridView.setItem(this.item);
    }

    deactivate() {
        Logger.debug('FoamItemEnvironment.deactivate():', this.item);

        this.itemLayer.hide();
        this.contextManager.removeContext(this.context);
        this.validator.unwatchContainerItem(this.item);

        if (this.extractionMarkerView) this.extractionMarkerView.unsetFoam();
        if (this.guideManager) this.gridView.unsetItem(this.item);
    }
}
